import { render, staticRenderFns } from "./SelectCompanyProductCollections.vue?vue&type=template&id=3369451d&"
import script from "./SelectCompanyProductCollections.vue?vue&type=script&lang=js&"
export * from "./SelectCompanyProductCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports